import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// List route
export const globalIncomingCallRoute: InvariantJiraRoute = {
	name: 'eoc-incoming-call',
	path: '/jira/settings/products/ops/incoming-call',
	exact: true,
};
